import { render, staticRenderFns } from "./EditEmailDialog.vue?vue&type=template&id=4bc300fc"
import script from "./EditEmailDialog.vue?vue&type=script&lang=js"
export * from "./EditEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports